const envVars = {
  backendURL: import.meta.env.VITE_BE_SERVICE,
};

export const getEnvVars = () => ({
  BE_SERVICE_ENDPOINT: envVars.backendURL,
  BE_SERVICE_URL: `${envVars.backendURL}/v3`,
});

export const setEnvVars = (payload) => {
  Object.assign(envVars, payload);
};

export const GUESTS_TYPE = {
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant',
};

export const MAX_MULTI_ROOMS = 4;

export const HOTEL_STRUCTURE_TYPES = {
  SINGLE: 'single',
  GROUP: 'group',
  MULTIPLE_PROPERTIES: 'multiple_properties',
};
